export const Header = () => (
  <header className="sticky top-0 z-50 bg-[#faf8f5]/95 backdrop-blur border-b border-[#2d4a22]/10 text-[#1f281e]">
    <nav
      className="max-w-6xl mx-auto px-6 h-24 flex items-center justify-between"
      aria-label="Main Navigation"
      data-testid="main-nav"
    >
      <a href="/" className="flex items-center group" data-testid="nav-logo" aria-label="Sahagun Landscape — home">
        <img
          src="/images/logo.png"
          alt="Sahagun Landscape"
          className="h-14 md:h-16 w-auto transition-transform duration-300 group-hover:scale-105"
        />
      </a>

      <div className="hidden md:flex items-center gap-7 text-sm font-medium tracking-wide uppercase">
        <a href="/#services" data-testid="nav-services" className="hover:text-[#2d4a22] transition-colors">Services</a>
        <a href="/#work" data-testid="nav-work" className="hover:text-[#2d4a22] transition-colors">Past Work</a>
        <a href="/#reviews" data-testid="nav-reviews" className="hover:text-[#2d4a22] transition-colors">Reviews</a>
        <a href="/about" data-testid="nav-about" className="hover:text-[#2d4a22] transition-colors">About Us</a>
        <a href="/careers" data-testid="nav-careers" className="hover:text-[#2d4a22] transition-colors">Careers</a>
        <a href="/#contact" data-testid="nav-contact" className="hover:text-[#2d4a22] transition-colors">Free Quote</a>
      </div>

      <a
        href="/#contact"
        data-testid="nav-quote-btn"
        className="inline-flex items-center justify-center px-5 py-2.5 text-xs uppercase tracking-widest font-semibold bg-[#2d4a22] text-[#faf8f5] hover:bg-[#1a2d14] transition-colors"
      >
        Get Quote
      </a>
    </nav>
  </header>
);
